import { vtexConstants } from '@constants/vtex';
import { vtexIntegrationService } from '@services';

export const vtexActions = {
    get,
    reset,
};

function get() {
    return dispatch => {
        dispatch(request());
        return vtexIntegrationService.getAccounts().then(
            data => dispatch(success(data)),
            error => dispatch(failure(error)),
        );
    };
}

function request() {
    return { type: vtexConstants.VTEX_ACCOUNTS_REQUEST };
}

function success(data) {
    return { type: vtexConstants.VTEX_ACCOUNTS_SUCCESS, data };
}

function failure(message) {
    return { type: vtexConstants.VTEX_ACCOUNTS_ERROR, message };
}

function reset() {
    return { type: vtexConstants.VTEX_ACCOUNTS_RESET };
}
